import { browser_utils } from "../frfr-browser-utils";
import { Easy69_v1 } from "../frfr-easy69-utils";
import { js_utils } from "../frfr-js-utils";
import { viarouter69_create_v3b } from "../frfr-viarouter69-temp-v3";
import { _zzyourmap_lib_tab_keys } from "./zz-yourmap-data-keys-and-values-lib";


//
export const _zzyourmap_routing_tab_keys = _zzyourmap_lib_tab_keys;
//
export const _zzyourmap_routing_static_pages_keys = ['o-nama', 'kontakt', 'uslovi', 'privatnost'];


// routes href maker - make href for use in Navigate function
export const yourmapNavMaker = {};
// slug (destination_slug) can also be route_destination_id
yourmapNavMaker.ROOT_HOME = () => '/'; //
yourmapNavMaker.static_page = (href) => href; //
//
yourmapNavMaker.ROOT_DESTINATION_LIST = () => '/destinacije';
yourmapNavMaker.ROOT_DESTINATION_ITEM = (slug) => ('/istrazi/' + slug + '/smestaji');
yourmapNavMaker.ROOT_MAP = (slug) => ('/mapa/' + slug);
//
yourmapNavMaker.smestaj_list = (slug) => ('/istrazi/' + slug + '/smestaji');
yourmapNavMaker.restoran_list = (slug) => ('/istrazi/' + slug + '/restorani');
yourmapNavMaker.servis_list = (slug) => ('/istrazi/' + slug + '/servisi');
yourmapNavMaker.prodavnica_list = (slug) => ('/istrazi/' + slug + '/prodavnice');
yourmapNavMaker.aktivnost_list = (slug) => ('/istrazi/' + slug + '/aktivnosti');
yourmapNavMaker.znamenitost_list = (slug) => ('/istrazi/' + slug + '/znamenitosti');
yourmapNavMaker.ostalo_list = (slug) => ('/istrazi/' + slug + '/ostalo');
yourmapNavMaker.blog_list = (slug) => ('/istrazi/' + slug + '/blog');
//
yourmapNavMaker.ROOT_SMESTAJ_ITEM = (slug, thing_id) => ('/istrazi/' + slug + '/smestaji/' + thing_id);
yourmapNavMaker.ROOT_RESTORAN_ITEM = (slug, thing_id) => ('/istrazi/' + slug + '/restorani/' + thing_id);
yourmapNavMaker.ROOT_SERVIS_ITEM = (slug, thing_id) => ('/istrazi/' + slug + '/servisi/' + thing_id);
yourmapNavMaker.ROOT_PRODAVNICA_ITEM = (slug, thing_id) => ('/istrazi/' + slug + '/prodavnice/' + thing_id);
yourmapNavMaker.ROOT_AKTIVNOST_ITEM = (slug, thing_id) => ('/istrazi/' + slug + '/aktivnosti/' + thing_id);
yourmapNavMaker.ROOT_ZNAMENITOST_ITEM = (slug, thing_id) => ('/istrazi/' + slug + '/znamenitosti/' + thing_id);
yourmapNavMaker.ROOT_OSTALO_ITEM = (slug, thing_id) => ('/istrazi/' + slug + '/ostalo/' + thing_id);
yourmapNavMaker.ROOT_BLOG_ITEM = (slug, thing_id) => ('/istrazi/' + slug + '/blog/' + thing_id);
//


//
export const _zzyourmap_routing_browser_title_update = (title) => {
  let _title = 'YOURMAP - Tvoje omiljene mape.';
  if (typeof title === 'string' && title.trim() !== '') {
    _title = `YOURMAP - Tvoje omiljene mape. | ${title}`;
  } else if (title === 404 || title === '404') {
    _title = 'Stranica nije pronađena | YOURMAP - Tvoje omiljene mape.';
  }
  browser_utils.browser_title_set(_title);
};


//
export const _zzyourmap_routing_browser_url_update = (viarouter69_href) => {
  console.log('_zzyourmap_routing_browser_url_update', viarouter69_href);
  // const _config_routing_by_hash = true;
  const _config_routing_by_hash = false;
  if (_config_routing_by_hash) { // update url fragment #
    window.location.hash = viarouter69_href;
  } else { // TODO
    // wiwindow.location.pathname = viarouter69_href;
    const url = viarouter69_href;
    window.history.pushState(null, '', url);
  }
};
//
export const _zzyourmap_routing_browser_url_event_popdtate_get_path = (e) => {
  // const _config_routing_by_hash = true;
  const _config_routing_by_hash = false;
  if (_config_routing_by_hash) { // update url fragment #
    console.log('_zzyourmap_routing_browser_url_event_popdtate_get_path(e)', e);
    let path = '';
    let _fragment = window.location.hash;
    if (js_utils.is_string_not_empty(_fragment)) {
      path = _fragment;
      if (_fragment.startsWith('#')) {
        path = _fragment.slice(1);
      }
    }
    console.log('path', path);
    // const _routeState = _zzyourmap_routing_path_to_routeState(path);
    // console.log('* POPSTATE to _routeState', _routeState);
    return path;
  } else { // TODO
    console.log('_zzyourmap_routing_browser_url_event_popdtate_get_path(e)', e);
    let path = '';
    let _url_path = window.location.pathname;
    if (js_utils.is_string_not_empty(_url_path)) {
      path = _url_path;
      if (_url_path.startsWith('#')) {
        path = _url_path.slice(1);
      }
    }
    console.log('path', path);
    // const _routeState = _zzyourmap_routing_path_to_routeState(path);
    // console.log('* POPSTATE to _routeState', _routeState);
    return path;
  }
};


//
const _zzyourmap_routing_fix_slug = (path_segment) => {
  if (typeof path_segment === 'string') {
    if (Number.parseInt(path_segment) > 0) {
      const id = Number.parseInt(path_segment);
      return id;
    } else {
      const destination_slug = path_segment;
      return destination_slug;
    }
  } else {
    return path_segment;
  }
};


//
export const _zzyourmap_routing_routeState_to_path = (_routeState) => {
  const {
    route_root,
    route_destination_id,
    route_subdestination_id,
    route_destination_tab,
    route_smestaj_id,
  } = _routeState;
  console.log('_zzyourmap_routing_routeState_to_path(_routeState)', _routeState);
  /*
  const _routeState = {
    route_root,
    route_destination_id,
    route_subdestination_id,
    route_destination_tab,
    route_smestaj_id,
  };
  */
  const destination_slug = route_destination_id;
  let path = '/';
  if (route_root === 'ROOT_HOME') {
    path = '/';
  } else if (route_root === 'ROOT_DESTINATION_LIST') {
    path = '/destinacije';
  } else if (route_root === 'ROOT_DESTINATION_ITEM') {
    path = '/istrazi';
    path += '/' + destination_slug;
    let is_tab_default = false;
    if (route_destination_tab === null) {
      is_tab_default = true;
    }
    if (is_tab_default || route_destination_tab === 'smestaji') {
      path += '/smestaji';
    } else if (route_destination_tab === 'restorani') {
      path += '/restorani';
    } else if (route_destination_tab === 'servisi') {
      path += '/servisi';
    } else if (route_destination_tab === 'prodavnice') {
      path += '/prodavnice';
    } else if (route_destination_tab === 'aktivnosti') {
      path += '/aktivnosti';
    } else if (route_destination_tab === 'znamenitosti') {
      path += '/znamenitosti';
    } else if (route_destination_tab === 'ostalo') {
      path += '/ostalo';
    } else if (route_destination_tab === 'blog') {
      path += '/blog';
    }
  } else if (route_root === 'ROOT_MAP') {
    path = '/mapa';
    path += '/' + destination_slug;
  } else if (route_root === 'ROOT_SMESTAJ_ITEM') {
    path = '/istrazi';
    path += '/' + destination_slug;
    path += '/smestaji';
    path += '/' + route_smestaj_id;
  } else if (route_root === 'ROOT_RESTORAN_ITEM') {
    path = '/istrazi';
    path += '/' + destination_slug;
    path += '/restorani';
    path += '/' + route_smestaj_id;
  } else if (route_root === 'ROOT_SERVIS_ITEM') {
    path = '/istrazi';
    path += '/' + destination_slug;
    path += '/servisi';
    path += '/' + route_smestaj_id;
  } else if (route_root === 'ROOT_PRODAVNICA_ITEM') {
    path = '/istrazi';
    path += '/' + destination_slug;
    path += '/prodavnice';
    path += '/' + route_smestaj_id;
  } else if (route_root === 'ROOT_AKTIVNOST_ITEM') {
    path = '/istrazi';
    path += '/' + destination_slug;
    path += '/aktrivnosti';
    path += '/' + route_smestaj_id;
  } else if (route_root === 'ROOT_ZNAMENITOST_ITEM') {
    path = '/istrazi';
    path += '/' + destination_slug;
    path += '/znamenitosti';
    path += '/' + route_smestaj_id;
  } else if (route_root === 'ROOT_OSTALO_ITEM') {
    path = '/istrazi';
    path += '/' + destination_slug;
    path += '/ostalo';
    path += '/' + route_smestaj_id;
  } else if (route_root === 'ROOT_BLOG_ITEM') {
    path = '/istrazi';
    path += '/' + destination_slug;
    path += '/blog';
    path += '/' + route_smestaj_id;
  } else {
    // ROUTE NOT FOUND
  }
  //
  return path;
};


//
export const _zzyourmap_routing_path_to_routeState_v1_OLD = (path) => {
  const _routeState = {
    route_root: null,
    route_destination_id: null,
    route_subdestination_id: null,
    route_destination_tab: null,
    route_smestaj_id: null,
    route_static_page: null,
  };
  _routeState.route_root = 'NOT_FOUND';
  let exploded_path = [];
  if (typeof path === 'string') {
    exploded_path = path.split('/');
  }
  if (exploded_path.length > 1) { // CASE something after /
    const path_tokens = exploded_path.slice(1); // remove first ''
    console.log('path_tokens', path_tokens);
    if (path_tokens.length === 1 && path_tokens[0] === '') {
      _routeState.route_root = 'ROOT_HOME';
    } else if (path_tokens.length === 1 && path_tokens[0] === 'destinacije') {
      _routeState.route_root = 'ROOT_DESTINATION_LIST';
    } else if ((path_tokens.length === 3 || path_tokens.length === 4) && path_tokens[0] === 'istrazi') {
      _routeState.route_root = 'ROOT_DESTINATION_ITEM';
      _routeState.route_destination_id = null;
      if (path_tokens[1]) {
        // _routeState.route_destination_id = path_tokens[1];
        // _routeState.route_destination_id = Number.parseInt(path_tokens[1]); // TODO
        const destination_slug = _zzyourmap_routing_fix_slug(path_tokens[1]);
        _routeState.route_destination_id = destination_slug; // TODO
        const tab = path_tokens[2];
        if (tab === 'smestaji') {
          _routeState.route_destination_tab = 'smestaji';
          if (path_tokens[3]) {
            _routeState.route_root = 'ROOT_SMESTAJ_ITEM';
            _routeState.route_smestaj_id = Number.parseInt(path_tokens[3]); // TODO
          }
        } else if (tab === 'restorani') {
          _routeState.route_destination_tab = 'restorani';
          if (path_tokens[3]) {
            _routeState.route_root = 'ROOT_RESTORAN_ITEM';
            _routeState.route_smestaj_id = Number.parseInt(path_tokens[3]); // TODO
          }
        } else if (tab === 'servisi') {
          _routeState.route_destination_tab = 'servisi';
          if (path_tokens[3]) {
            _routeState.route_root = 'ROOT_SERVIS_ITEM';
            _routeState.route_smestaj_id = Number.parseInt(path_tokens[3]); // TODO
          }
        } else if (tab === 'prodavnice') {
          _routeState.route_destination_tab = 'prodavnice';
          if (path_tokens[3]) {
            _routeState.route_root = 'ROOT_PRODAVNICA_ITEM';
            _routeState.route_smestaj_id = Number.parseInt(path_tokens[3]); // TODO
          }
        } else if (tab === 'aktivnosti') {
          _routeState.route_destination_tab = 'aktivnosti';
          if (path_tokens[3]) {
            _routeState.route_root = 'ROOT_AKTIVNOST_ITEM';
            _routeState.route_smestaj_id = Number.parseInt(path_tokens[3]); // TODO
          }
        } else if (tab === 'ostalo') {
          _routeState.route_destination_tab = 'ostalo';
          if (path_tokens[3]) {
            _routeState.route_root = 'ROOT_OSTALO_ITEM';
            _routeState.route_smestaj_id = Number.parseInt(path_tokens[3]); // TODO
          }
        } else {
          _routeState.route_root = 'NOT_FOUND';
        }
      }
    } else if (path_tokens.length === 2 && path_tokens[0] === 'mapa') {
      _routeState.route_root = 'ROOT_MAP';
      console.log('++++ mapa');
      if (path_tokens[1]) {
        // _routeState.route_destination_id = Number.parseInt(path_tokens[1]); // TODO
        const destination_slug = _zzyourmap_routing_fix_slug(path_tokens[1]);
        _routeState.route_destination_id = destination_slug; // TODO
      }
    } else if (path_tokens.length === 1 && Easy69_v1.is_value_in_array(path_tokens[0], _zzyourmap_routing_static_pages_keys)) {
      _routeState.route_root = 'ROOT_STATIC_PAGE';
      _routeState.route_static_page = path_tokens[0];
    } else {
      _routeState.route_root = 'NOT_FOUND';
    }
  }
  // TODO
  if (_routeState.route_root === 'NOT_FOUND') {
    _routeState.route_root = 'ROOT_HOME';
  }
  //
  return _routeState;
};


//
export const _zzyourmap_routing_path_to_routeState = (path) => {
  const _routeState = {
    route_root: null,
    route_destination_id: null,
    route_subdestination_id: null,
    route_destination_tab: null,
    route_smestaj_id: null,
    route_static_page: null,
  };
  _routeState.route_root = 'NOT_FOUND';
  //
  //
  ////
  let route_root_v2;
  // const path = viarouter_current_path;
  console.log('path', path);
  const router = viarouter69_create_v3b();
  //
  router.addRoute('/', (req, res, next) => { // route_root === 'ROOT_HOME'
    _routeState.route_root = 'ROOT_HOME';
  });
  //
  router.addRoute('/destinacije', (req, res, next) => { // route_root === 'ROOT_DESTINATION_LIST') {
    _routeState.route_root = 'ROOT_DESTINATION_LIST';
  });
  //
  // with subrouter tabs
  router.addRoute('/istrazi/:slug/:tab/', (req, res, next) => { // route_root === 'ROOT_DESTINATION_ITEM' ***
    route_root_v2 = 'ROOT_DESTINATION_ITEM';
    // const id = req.params.id;
    const slug = req.params.slug;
    const tab = req.params.tab;
    console.log('req', req);
    console.log('tab', tab);
    if (Easy69_v1.is_value_in_array(tab, _zzyourmap_routing_tab_keys) !== true) {
      console.log('ROUTING ERROR: tab NOT EXIST');
      _routeState.route_root = 'NOT_FOUND';
      // return jsxNotFound;
    } else {
      _routeState.route_root = 'ROOT_DESTINATION_ITEM';
      const destination_slug = _zzyourmap_routing_fix_slug(slug);
      _routeState.route_destination_id = destination_slug;
      _routeState.route_destination_tab = tab;
    }
    // SUBROUTER...
  });
  //
  router.addRoute('/istrazi/:slug/:tab/:thing_id', (req, res, next) => { // route_root === 'ROOT_SMESTAJ_ITEM'
    route_root_v2 = 'ROOT_SMESTAJ_ITEM';
    // const id = req.id;
    const slug = req.params.slug;
    const tab = req.params.tab;
    const thing_id = req.params.thing_id;
    console.log('req', req);
    if (Easy69_v1.is_value_in_array(tab, _zzyourmap_routing_tab_keys) !== true) {
      console.log('ROUTING ERROR: tab NOT EXIST');
      _routeState.route_root = 'NOT_FOUND';
      // return jsxNotFound; 
    } else {
      _routeState.route_root = 'ROOT_SMESTAJ_ITEM'; // TODO
      const destination_slug = _zzyourmap_routing_fix_slug(slug);
      _routeState.route_destination_id = destination_slug;
      _routeState.route_destination_tab = tab;
      _routeState.route_smestaj_id = Number.parseInt(thing_id); // TODO
      if (tab === 'smestaji') {
        _routeState.route_root = 'ROOT_SMESTAJ_ITEM';
      } else if (tab === 'restorani') {
        _routeState.route_root = 'ROOT_RESTORAN_ITEM';
      } else if (tab === 'servisi') {
        _routeState.route_root = 'ROOT_SERVIS_ITEM';
      } else if (tab === 'prodavnice') {
        _routeState.route_root = 'ROOT_PRODAVNICA_ITEM';
      } else if (tab === 'aktivnosti') {
        _routeState.route_root = 'ROOT_AKTIVNOST_ITEM';
      } else if (tab === 'znamenitosti') {
        _routeState.route_root = 'ROOT_ZNAMENITOST_ITEM';
      } else if (tab === 'ostalo') {
        _routeState.route_root = 'ROOT_OSTALO_ITEM';
      } else if (tab === 'blog') {
        _routeState.route_root = 'ROOT_BLOG_ITEM';
      }
    }
  });
  //
  router.addRoute('/mapa/:slug', (req, res, next) => { // route_root === 'ROOT_MAP'
    //
    const slug = req.params.slug;
    console.log('req', req);
    _routeState.route_root = 'ROOT_MAP';
    const destination_slug = _zzyourmap_routing_fix_slug(slug);
    _routeState.route_destination_id = destination_slug; // TODO
  });
  //
  //
  router.addRoute('/:static_page_key', (req, res, next) => { // route_root === 'ROOT_STATIC_PAGE'
    //
    // route_root_v2 = 'ROOT_STATIC_PAGE';
    const static_page_key = req.params.static_page_key;
    console.log('req', req);
    if (Easy69_v1.is_value_in_array(static_page_key, _zzyourmap_routing_static_pages_keys) !== true) {
      console.log('ROUTING ERROR: tab NOT EXIST');
      _routeState.route_root = 'NOT_FOUND';
      // return jsxNotFound;
    } else {
      _routeState.route_root = 'ROOT_STATIC_PAGE';
      _routeState.route_static_page = static_page_key;
    }
  });
  //
  //
  //
  const [returned_value_from_router, status_is_finished_with_succes] = router.execute(path).get_returned_value('Ooops :(');
  console.log('router', router);
  console.log('path', path, ' --> detected _routeState', _routeState);
  // TODO
  if (_routeState.route_root === 'NOT_FOUND') {
    _routeState.route_root = 'ROOT_HOME';
  }
  //
  return _routeState;
};


//
const _push_prev_state_to_history = (_routeStatePrev) => {
  window.history.pushState({
    _routeState: _routeStatePrev,
    is_valid_browser_history_state: true,
  }, null, '/');
  // }, null, _zzyourmap_routing_routeState_to_path(_routeStatePrev));
};


//
export const _zzyourmap_routing_navigating_to = (_routeState, _routeStatePrev) => {
  //
  // _push_prev_state_to_history(_routeStatePrev);
  const path = _zzyourmap_routing_routeState_to_path(_routeState);
  // window.location.hash = path;
  _zzyourmap_routing_browser_url_update(path);
};


//
export const _zzyourmap_routing_event_popstate = (e) => {
  console.log('_zzyourmap_routing_event_popstate(e)', e);
  let path = '';
  let _fragment = window.location.hash;
  if (js_utils.is_string_not_empty(_fragment)) {
    path = _fragment;
    if (_fragment.startsWith('#')) {
      path = _fragment.slice(1);
    }
  }
  console.log('path', path);
  const _routeState = _zzyourmap_routing_path_to_routeState(path);
  console.log('* POPSTATE to _routeState', _routeState);
  return _routeState;
};


//
/*
export const _zzyourmap_routing_navigating_to
*/
